import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from '@/App.vue'
import Linktree from '@/core/components/Main-Linktree.vue'
import Login from '@/core/components/Main-login.vue'
import Logout from '@/core/components/Main-logout.vue'
import SortTest from '@/core/components/Sort-Test.vue'

import '@/assets/style.css'
import {firebaseConfig, firebase_dbpath} from './config/firebase.config';
import portrait from './assets/portrait.jpg';

const routes = [
    { path: '/', component: Linktree },
    { path: '/login', component: Login },
    { path: '/logout', component: Logout },
    { path: '/sort', component: SortTest },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})
const app = createApp(App)
app.use(router)
app.provide('firebaseConfig', firebaseConfig)
app.provide('firebase_dbpath', firebase_dbpath)
app.provide('portrait', portrait)
app.mount('#app')